<template>
    <CardSection :error="majorError" :loading="isSavableStateLoading">
    <template #header>
      Troubleshoot Robocall Reduction
    </template>
    <template #body>
      <UnetEmails
      :records="records" 
      :total-records="totalRecords"
      :page-number="pageNumber" 
      :page-count="pageCount"
      :is-savable-state-processing="isSavableStateProcessing" 
      :filter-values="filterValues"
      @sortChange="handleSortChange"
      @pageChange="handlePageChange"
      @filterChange="onFilterChange"
      />

      <IncomingSMSLogsTable
        :incoming-sms-logs="incomingSMSLogs" 
        :sms-total-records="smsTotalRecords"
        :sms-page-number="smsPageNumber" 
        :sms-page-count="smsPageCount"
        :is-savable-state-processing="isSavableStateProcessing" 
        :sms-filter-values="smsFilterValues"
        @sortChange="handleSMSSortChange"
        @pageChange="handleSMSPageChange"
        @filterChange="onSMSFilterChange"
      />

      <IncomingCallLogsTable
        :incoming-call-logs="incomingCallLogs" 
        :call-total-records="callTotalRecords"
        :call-page-number="callPageNumber" 
        :call-page-count="callPageCount"
        :is-savable-state-processing="isSavableStateProcessing" 
        :call-filter-values="callFilterValues"
        @sortChange="handleCallSortChange"
        @pageChange="handleCallPageChange"
        @filterChange="onCallFilterChange"
      />
    </template>
  </CardSection>
</template> 
<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { pageMixin } from "@/src/mixins/pageMixin";
import { FilterMatchMode } from '@primevue/core/api';
import { useRobocallReductionsStore } from '@/src/stores/robocall_reductions';
import { paginationMixin } from "@/src/mixins/paginationMixin";
import IncomingCallLogsTable from '@/src/components/admin-area/troubleshoot/robocall/IncomingCallLogsTable.vue'; 
import IncomingSMSLogsTable from '@/src/components/admin-area/troubleshoot/robocall/IncomingSMSLogsTable.vue'; 
import UnetEmails from '@/src/components/admin-area/troubleshoot/robocall/UnetEmails.vue'; 

export default {
   components: {
    CardSection,
    IncomingCallLogsTable,
    IncomingSMSLogsTable,
    UnetEmails,
  },
  mixins: [ savableStateMixin, pageMixin, paginationMixin ],
  setup() {
    const robocallReductionsStore = useRobocallReductionsStore();
    return {
      robocallReductionsStore
    }
  },
   data() {
    return {
      incomingSMSLogs: [],
      incomingCallLogs: [],
      majorError: null,
      smsPageNumber: 1,
      smsPageCount: null,
      callPageNumber: 1,
      callPageCount: null,
      smsSortField: '',
      smsSortType: '',
      sms_search_params: {},
      callSortField: '',
      callSortType: '',
      call_search_params: {},

      filterValues: {
        "email_type" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "recipient" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      },
      smsFilterValues: {
        "user_email" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "handling_status" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "from_phone_number": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "forwarded_phone_number": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      },
      callFilterValues: {
        "user_email" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "handling_status" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "caller_phone_number": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "forwarded_phone_number": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      },          
    }
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      await this.robocallReductionsStore.loadTransplantCentres();
      await this.robocallReductionsStore.loadOrganGroups();
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error); 
    }
  },
  methods: {   
    async getRowData(reset = false) {
      this.setSavableStateProcessing();
      if (reset) this.pageNumber = 1;

      let params = {
        page: this.pageNumber,
        sort_by: this.currentSortField,
        sort_type: this.currentSortType,
      };

      params = { ...this.searchParams, ...params };
      try {
        const response = await this.robocallReductionsStore.loadUnetEmails(params);
        this.processPagyResponse(response);
        this.setSavableStateIdle();
      } catch(error) {
      this.handleMajorError(error);  
      }
    },
    async loadIncomingSMSLogs(reset = false) {
      if (reset) this.smsPageNumber = 1;
      let params = {
        page: this.smsPageNumber,
        sort_by: this.smsSortField,
        sort_type: this.smsSortType,
      };
      params = { ...this.sms_search_params, ...params };
      try {
        const response = await this.robocallReductionsStore.loadIncomingSMSLogs(params);
        this.incomingSMSLogs = response.data
        this.smsTotalRecords = response.pagy.count;
        this.smsPageCount = response.pagy.last;
        this.smsPageNumber = response.pagy.page;
      } catch(error) {
        this.handleMajorError(error);  
      }
    },
     async loadIncomingCallLogs(reset = false) {
       if (reset) this.callPageNumber = 1;
      let params = {
        page: this.callPageNumber,
        sort_by: this.callSortField,
        sort_type: this.callSortType,
      };
      params = { ...this.call_search_params, ...params };
      try {
        const response = await this.robocallReductionsStore.loadIncomingCallLogs(params);
        this.incomingCallLogs = response.data
        this.callTotalRecords = response.pagy.count;
        this.callPageCount = response.pagy.last;
        this.callPageNumber = response.pagy.page;
      } catch(error) {
        this.handleMajorError(error);  
      }
    },
    handleSMSPageChange(page) {
      this.smsPageNumber = page;
      this.loadIncomingSMSLogs();
    },
    handleSMSSortChange(params) {
      this.smsSortField = params.sortField;    
      switch(params.sortOrder) {
        case 1:
          this.smsSortType = 'asc';
          break;
        case -1:
          this.smsSortType = 'desc';
          break;
        default:
          this.smsSortType = null;
      }
      this.loadIncomingSMSLogs();
    },
    handleCallPageChange(page) {
      this.callPageNumber = page;
      this.loadIncomingCallLogs();
    },
    handleCallSortChange(params) {
      this.callSortField = params.sortField;
      switch(params.sortOrder) {
        case 1:
          this.callSortType = 'asc';
          break;
        case -1:
          this.callSortType = 'desc';
          break;
        default:
          this.callSortType = null;
      }
      this.loadIncomingCallLogs();
    },
    
    onFilterChange(event) {
      this.searchParams = event;   
      this.getRowData(true);
    },
    onSMSFilterChange(event) {   
      this.sms_search_params = event;
      this.loadIncomingSMSLogs(true);
    },   
    onCallFilterChange(event) {
      this.call_search_params = event;
      this.loadIncomingCallLogs(true);
    },   
  }
}
</script>